import { render, staticRenderFns } from "./core_columns.vue?vue&type=template&id=421b8a10&scoped=true"
import script from "./core_columns.vue?vue&type=script&lang=js"
export * from "./core_columns.vue?vue&type=script&lang=js"
import style0 from "./core_columns.vue?vue&type=style&index=0&id=421b8a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421b8a10",
  null
  
)

export default component.exports